import { List } from 'immutable';
import Availability from 'MeetingsBase/models/Availability';
import TimeRange from 'MeetingsBase/models/TimeRange';
import AvailableTimeChunk from 'MeetingsBase/models/AvailableTimeChunk';
export function getChunkListFromRecord(availability) {
  return availability.reduce(function (acc, listTimeRanges, day) {
    var timeChunksForDay = listTimeRanges.map(function (timeRange) {
      return new AvailableTimeChunk({
        day: day,
        startMinute: timeRange.start,
        endMinute: timeRange.end
      });
    });
    return acc.concat(timeChunksForDay);
  }, List());
}
export function getRecordFromChunkList(availableTimeChunks) {
  return availableTimeChunks.reduce(function (acc, timeChunk) {
    return acc.update(timeChunk.day, function (timeChunksForDay) {
      return timeChunksForDay.push(TimeRange.from({
        start: timeChunk.startMinute,
        end: timeChunk.endMinute
      }));
    });
  }, new Availability());
}